export default __webpack_public_path__ + "static/3-9039687679341062b2b84c039b1e88cf.jpg";